import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="relative py-12 px-4 border-t border-dark-border bg-deepspace/50 z-30">
      <div className="max-w-7xl mx-auto relative z-30">
        {/* Brand Section - Full Width on Mobile */}
        <div className="mb-8">
          <Link to="/" className="flex items-center mb-4">
            <img 
              src="/images/logos/aureumvault-light-logo.png" 
              alt="AureumVault Logo" 
              className="h-10 w-auto object-contain"
            />
          </Link>
          <p className="text-text-secondary text-sm text-left max-w-xs">
            Securing the future of digital assets with AI-powered protection.
          </p>
        </div>

        {/* Links Grid - 2 Columns on Mobile, 3 Columns on Desktop */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-6 md:gap-8 mb-8 relative z-30">
          <div className="text-left">
            <h4 className="font-bold text-text-primary mb-4">Product</h4>
            <ul className="space-y-2 text-text-secondary text-sm">
              <li><Link to="/features" className="hover:text-cyber-blue transition-colors duration-300 cursor-pointer">Features</Link></li>
              <li><Link to="/security" className="hover:text-cyber-blue transition-colors duration-300 cursor-pointer">Security</Link></li>
              <li><Link to="/how-it-works" className="hover:text-cyber-blue transition-colors duration-300 cursor-pointer">How It Works</Link></li>
              <li><Link to="/about" className="hover:text-cyber-blue transition-colors duration-300 cursor-pointer">About</Link></li>
            </ul>
          </div>

          <div className="text-left">
            <h4 className="font-bold text-text-primary mb-4">Company</h4>
            <ul className="space-y-2 text-text-secondary text-sm">
              <li><Link to="/about" className="hover:text-cyber-blue transition-colors duration-300 cursor-pointer">About Us</Link></li>
              <li><a href="#contact" className="hover:text-cyber-blue transition-colors duration-300 cursor-pointer">Contact</a></li>
              <li><a href="#support" className="hover:text-cyber-blue transition-colors duration-300 cursor-pointer">Support</a></li>
              <li><Link to="/auth" className="hover:text-cyber-blue transition-colors duration-300 cursor-pointer">Get Started</Link></li>
            </ul>
          </div>

          <div className="text-left col-span-2 md:col-span-1">
            <h4 className="font-bold text-text-primary mb-4">Legal</h4>
            <ul className="space-y-2 text-text-secondary text-sm">
              <li><a href="#privacy" className="hover:text-cyber-blue transition-colors duration-300 cursor-pointer">Privacy Policy</a></li>
              <li><a href="#terms" className="hover:text-cyber-blue transition-colors duration-300 cursor-pointer">Terms of Service</a></li>
              <li><a href="#cookies" className="hover:text-cyber-blue transition-colors duration-300 cursor-pointer">Cookie Policy</a></li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-dark-border text-left md:text-center text-text-secondary text-sm">
          <p>&copy; 2025 AureumVault. All rights reserved. Built with 🔒 for Web3.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

